import LogoWithLink from '@common/components/Logo/LogoWithLink';
import { useTranslation } from '@client-app/i18n';
import { useNavigate } from 'react-router-dom';

const OnboardingFailurePage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);
    const workspaceId = searchParams.get('workspace_id');
    const retryUrl = workspaceId
        ? `/onboarding?resume_workspace_id=${encodeURIComponent(workspaceId)}&resume_step=plan`
        : '/onboarding';

    return (
        <div className="min-h-screen bg-[#F8F9FB] flex flex-col">
            <div className="fixed top-8 left-8">
                <LogoWithLink size="26px" />
            </div>
            <div className="flex-1 flex items-center justify-center px-6">
                <div className="w-full max-w-lg rounded-[28px] bg-white shadow-[0_20px_80px_rgba(15,23,42,0.08)] border border-[#E7EAF1] p-10 text-center">
                    <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-[#FEF2F2] text-[#B91C1C]">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                            <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                            <circle cx="12" cy="16" r="1" fill="currentColor" />
                        </svg>
                    </div>
                    <h1 className="text-[28px] font-semibold text-[#111827]">{t('website.onboarding.failure.title')}</h1>
                    <p className="mt-3 text-[15px] leading-7 text-[#6B7280]">
                        {t('website.onboarding.failure.description')}
                    </p>
                    <div className="mt-8 flex flex-col gap-3">
                        <button
                            type="button"
                            onClick={() => navigate(retryUrl, { replace: true })}
                            className="h-11 rounded-xl bg-[#111827] text-white font-medium hover:bg-[#1F2937] transition-colors"
                        >
                            {t('website.onboarding.failure.returnToOnboarding')}
                        </button>
                        <button
                            type="button"
                            onClick={() => navigate('/', { replace: true })}
                            className="h-11 rounded-xl border border-[#D1D5DB] text-[#111827] font-medium hover:bg-[#F9FAFB] transition-colors"
                        >
                            {t('website.onboarding.failure.goToAdmin')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OnboardingFailurePage;
